import { Component, OnInit } from '@angular/core';
import { EducationComponent } from '../education.component';

@Component({
  selector: 'app-touch-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['../education.component.scss']
})
export class EducationPanelComponent extends EducationComponent implements OnInit{
  public ngOnInit(): void {
    super.ngOnInit();
  }
}
